import { useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import Collapse from '@material-ui/core/Collapse';

import { TRACK_EVENT_NAMES, TRACK_CATEGORIES, trackEvent } from 'lib/tracking';

import { colors } from 'styles/theme';

import ArrowDownIcon from 'components/shared/icons/ArrowDownIcon';
import RichText from 'components/shared/RichText/RichText';
import Text from 'components/shared/Text/Text';
import Flexbox from 'components/shared/Flexbox/Flexbox';
import ButtonBase from 'components/shared/ButtonBase/ButtonBase';

const questionCss = css`
  border-bottom: 1px solid ${colors.borderGray};
`;

const questionHeaderCss = css`
  display: block;
  width: 100%;
  padding: 20px 0;

  &:hover {
    cursor: pointer;
  }
`;

const arrowDownIconCss = rotateUp => css`
  width: 1.2em;
  height: 1.2em;
  transform: ${rotateUp && 'rotate(180deg)'};
  transition: transform 200ms ease-out;
  margin-right: 10px;
  margin-left: 15px;
`;

function FaqQuestion({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  function handleQuestionClick() {
    // Track a click when a question is being opened
    if (!isOpen) {
      trackEvent(TRACK_EVENT_NAMES.FAQ, {
        category: TRACK_CATEGORIES.FAQ_QUESTION,
        label: question,
      });
    }

    setIsOpen(!isOpen);
  }

  return (
    <div css={questionCss}>
      {/* Question */}
      <ButtonBase css={questionHeaderCss} onClick={handleQuestionClick}>
        <Flexbox alignItems="center" justifyContent="space-between">
          <Text
            textAlign="left"
            component="h3"
            fontWeight={isOpen ? 500 : 400}
            color={isOpen ? colors.darkPurple : 'inherit'}
          >
            {question}
          </Text>
          <ArrowDownIcon css={arrowDownIconCss(isOpen)} />
        </Flexbox>
      </ButtonBase>
      {/* Answer */}
      <Collapse in={isOpen}>
        <RichText text={answer} />
      </Collapse>
    </div>
  );
}

FaqQuestion.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.object.isRequired,
};

export default FaqQuestion;
